var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormSets.jinja');
require('./SubmissionFormSets.less');


var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({

    template: template,

    events: {
        'change input': 'changeFile'
    },


    tempFilesApi: function () {
        return (UrlsFront['front:api:files:temp-file-upload']());
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'tempFilesApi');

         //extract filename from full path
        var filename = this.$('.SubmissionFormSets-upload').attr('data-file');

        if (filename) {
            filename = filename.split('/');
            this.$('.SubmissionFormSets-filename a').text(filename[filename.length - 1]);
        }

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        this.resetFileLoading();

        return SubmissionFormBlock.prototype.deactivate.call(this, params);
    },


    changeFile: function (e) {
        if (!e.target.files || !e.target.files.length) return;

        this.resetFileLoading();

        var fil = e.target.files[0];
        var self = this;

        this.$('.SubmissionFormSets-upload').attr('data-state', 'loading');
        this.$('.SubmissionFormSets-filename a').text(fil.name);

        this.$('.SubmissionFormSets-filename span')
            .html('File Uploading:&nbsp;')
            .removeClass('error');

        this.fileLoadXhr = new XMLHttpRequest();
        this.fileLoadXhr.open('POST', this.tempFilesApi());

        this.fileLoadXhr.onload = function (res, data) {
            var responseObject = app.AdoptTempFileObject(this.responseText, 'file');

            self.$('.SubmissionFormSets-upload').attr('data-file', JSON.stringify(responseObject));
            self.$('.SubmissionFormSets-upload').attr('data-new', 1);
            self.$('.SubmissionFormSets-upload').attr('data-state', 'idle');
            self.$('.SubmissionFormSets-filename span').html('File Uploaded:&nbsp;');
            self.$('.SubmissionFormSets-filename a').attr('href', responseObject.tempFile);
        };

        this.fileLoadXhr.onerror = function () {
            self.$('.SubmissionFormSets-upload').attr('data-file', '');
            self.$('.SubmissionFormSets-upload').attr('data-state', 'idle');
            self.$('.SubmissionFormSets-filename span')
                .html('File Upload Error!')
                .addClass('error');
            self.$('.SubmissionFormSets-filename a').text('');
        };


        var formData = new FormData();
        formData.append('file', fil);
        this.fileLoadXhr.send(formData);

        $(e.currentTarget).val('');
    },


    resetFileLoading: function () {
        this.fileLoadXhr && this.fileLoadXhr.abort();
    },


    checkRequired: function () {
        if (!this.getFormData().setsTimingListPdf) {
            this.$el.flashClass('SubmissionFormSets--error', 1000);
            app.animateWindowScroll(this.$el.offset().top - 340);
            return false;
        }

        return true;
    },


    getFormData: function () {
        var $input = this.$('.SubmissionFormSets-upload');
        var fileData = $input.attr('data-file');
        fileData = fileData ? ($input.attr('data-new') ? JSON.parse(fileData) : fileData) : null;

        return {
            'setsTimingListPdf': fileData
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormSets.js
// module id = 122
// module chunks = 0